<template>
    <b-modal
        v-model="shown"
        centered
        :title="title"
        lazy
    >

        <div>
            <b-form-group class="mb-0">
                <div>
                    <label>Tab</label>
                </div>
                <Multiselect
                    v-model="$v.selectedTab.$model"
                    placeholder="Select a Tab..."
                    tag-placeholder="Add a Tab..."
                    track-by="id"
                    label="name"
                    selected-label=""
                    :options="tabOptions"
                    :multiple="false"
                    taggable
                    @tag="tag"
                />
                <b-form-invalid-feedback :force-show="$v.selectedTab.$dirty && !$v.selectedTab.required">
                    Please select a tab.
                </b-form-invalid-feedback>
            </b-form-group>
        </div>

        <div slot="modal-footer">
            <b-btn
                variant="default"
                class="mr-2"
                @click="close()"
            >
                Close
            </b-btn>
            <Button
                variant="success"
                :loading="submitLoading"
                :disabled="$v.$invalid"
                @click="handleSubmit()"
            >
                Save
            </Button>
        </div>

    </b-modal>
</template>

<script>
import vueComponentReset from '@ianwalter/vue-component-reset';
import Multiselect from 'vue-multiselect';
import required from 'vuelidate/lib/validators/required';

const resetMixin = vueComponentReset(() => ({
    shown: false,
    submitLoading: false,
    title: '',
    tabOptions: [],
    selectedTab: null,
    taggedTab: null,
    groupId: null,
    costIds: null,
}));

export default {

    components: {
        Multiselect,
    },

    mixins: [
        resetMixin,
    ],

    computed: {
        tabs() {
            return this.$store.getters['costable/tabs'];
        },
    },

    created() {
        this.$eventBus.$on(this.$events.openAddToTabModal, ({ title, groupId = null, costIds = null }) => {
            this.$v.$reset();
            this.reset();
            this.title = title;
            this.tabOptions = this.tabs;
            this.groupId = groupId;
            this.costIds = costIds;
            this.shown = true;
        });
    },

    validations: {
        selectedTab: {
            required,
        },
    },

    methods: {
        async handleSubmit() {
            this.submitLoading = true;

            let tabId = this.selectedTab.id;

            if (this.taggedTab) {
                // tab has just been tagged so let's add it to the db
                tabId = await this.$store.dispatch('costable/storeTab', {
                    name: this.taggedTab.name,
                });
            }

            if (this.groupId) {
                await this.$store.dispatch('costable/addGroupToTab', {
                    tabId,
                    groupId: this.groupId,
                });
            } else if (this.costIds) {
                await this.$store.dispatch('costable/addCostsToTab', {
                    tabId,
                    costIds: this.costIds,
                });
            }

            this.submitLoading = false;
            this.shown = false;
        },
        async tag(name) {
            const tab = {
                id: 0, // TODO refactor, if more than one tab is tagged, this won't work
                name,
            };
            this.tabOptions = [
                ...this.tabOptions,
                tab,
            ];
            this.selectedTab = tab;
            this.taggedTab = tab;
        },
        close() {
            this.shown = false;
        },
    },

};
</script>
